import { useEffect, useState } from "react";

export function MinimalTextInput({
  value,
  setValue,
  ariaLabel,
}: {
  value: string;
  setValue: (newValue: string) => void;
  ariaLabel?: string;
}) {
  const [internValue, setInternValue] = useState<string>(value);
  useEffect(() => {
    if (value != internValue) {
      setInternValue(value);
    }
  }, [value]);

  const commitValue = () => {
    if (internValue != value) {
      setValue(internValue);
    }
  };

  const handleKeyDown = (ev) => {
    if (ev.key === "Enter") {
      commitValue();
      ev.target.blur();
    }
    if (ev.key === "Escape") {
      setInternValue(value);
      ev.target.blur();
    }
  };

  return (
    <div className={"text-input"}>
      <input
        type={"text"}
        aria-label={ariaLabel}
        value={internValue ?? ""}
        onBlur={commitValue}
        onKeyDown={handleKeyDown}
        onChange={(e) => setInternValue(e.target.value)}
      />
    </div>
  );
}
